import React from "react";
import "./UserListCard.css";
import mobileIcon from "../../assets/icons/new-icons/mobile.svg";
import emailIcon from "../../assets/icons/new-icons/email.svg";
import cnicIcon from "../../assets/icons/new-icons/idcard.svg";
import locationIcon from "../../assets/icons/new-icons/location.svg";
import deleteIcon from "../../assets/icons/new-icons/delete.svg";
import editIcon from "../../assets/icons/new-icons/edit.svg";
import activeIcon from "../../assets/icons/new-icons/active.svg";
import reSend from "../../assets/icons/new-icons/reSend.svg";
import inactiveIcon from "../../assets/icons/new-icons/inactive.svg";
import invite from "../../assets/icons/new-icons/invite.svg";
import { stringAvatar } from "../../helpers/stringAvatar";
import { Avatar } from "@mui/material";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import OutboxIcon from "@mui/icons-material/Outbox";

const UserListCard = (props) => {
  const {
    name,
    date,
    email,
    phone,
    cnic,
    address,
    onEdit,
    onDelete,
    onClick,
    handleOpenInActveDialog,
    handleOpenActveDialog,
    handleCloseInActiveDialog,
    handleCloseDeleteDialog,
    status,
    onInvite,
    isMarketing,
    statusArray,
    index,
    lead,
  } = props;

  console.log("isMarketing", isMarketing);
  return (
    <div
      className="lead-listing-card"
      onClick={(e) => {
        if (!isMarketing) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="listing-card-header">
        <div className="left">
          <div className="user-avatar">
            {/* <img src="https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8YXZhdGFyc3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60" /> */}
            <Avatar {...stringAvatar(name)} />
          </div>
          <div>
            <div className="name">{name}</div>
            <div className="date">
              Added on:{" "}
              <span
                style={{
                  color: "#929292",
                }}
              >
                {date}
              </span>
            </div>
          </div>
        </div>
        {isMarketing ? (
          <div className="right">
            {statusArray[index] === true ? (
              <span className="icon">
                <MarkEmailReadIcon style={{ color: "green" }} />
              </span>
            ) : (
              lead.email && (
                <span className="icon" onClick={onClick}>
                  {" "}
                  <OutboxIcon style={{ color: "red" }} />{" "}
                </span>
              )
            )}
          </div>
        ) : (
          <div className="right">
            {status === "invite" && email !== "" && (
              <span
                className="icon"
                onClick={(e) => {
                  e.stopPropagation();
                  onInvite();
                }}
              >
                <img src={invite} />
              </span>
            )}
            {status === "active" && (
              <span
                className="icon"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenActveDialog();
                }}
              >
                <img src={inactiveIcon} />
              </span>
            )}

            {status === "inactive" && (
              <span
                className="icon"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenInActveDialog();
                }}
              >
                <img src={activeIcon} />
              </span>
            )}
            <span
              className="icon"
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
            >
              <img src={deleteIcon} />
            </span>

            <span
              className="icon"
              onClick={(e) => {
                e.stopPropagation();
                onEdit();
              }}
            >
              <img src={editIcon} />
            </span>
          </div>
        )}
      </div>

      <div className="listing-card-body">
        {phone && (
          <div className="card-element">
            <div className="icon">
              <img src={mobileIcon} />
            </div>
            <div className="detail">{phone}</div>
          </div>
        )}
        {email && (
          <div className="card-element">
            <div className="icon">
              <img src={emailIcon} />
            </div>
            <div className="detail">{email}</div>
          </div>
        )}
        {cnic && (
          <div className="card-element">
            <div className="icon">
              <img src={cnicIcon} />
            </div>
            <div className="detail">{cnic}</div>
          </div>
        )}
        {address && (
          <div className="card-element">
            <div className="icon">
              <img src={locationIcon} />
            </div>
            <div className="detail">{address}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserListCard;
